import { html } from "lit";
import { formatHtml } from "@trumpf/ux.common-storybook";
import {
    namespace,
    translations,
} from "../../mytrumpf/page-templates/my-machines/my-machines-detail/tabs/trainings";
import { addI18nTranslations } from "../../utils";

export default {
    title: "Components/Stateful Filter & Content/Stateful Content/Stateful Trainings",
    parameters: {
        docs: { source: { transform: formatHtml } },
        forceRender: true,
    },
    component: "ux-iws-stateful-trainings",
    args: { scope: "", url: "" },
    argTypes: {
        scope: { control: "text" },
        translations: { control: "Translations | string" },
        url: { control: "text" },
    },
};

const language = "de-DE";

addI18nTranslations({ namespace, translations, language });

const Template = () => {
    return html`
        <ux-iws-stateful-trainings
            scope="${namespace}"
            url="./generated-mock-data/mymachine-trainings-content.json"
            translations-namespace="${namespace}"
            language="${language}"
        ></ux-iws-stateful-trainings>
    `;
};

const TemplateWithFilter = ({ withTags }) =>
    html` <div class="ux-row">
            <div class="ux-col-12">
                <ux-iws-stateful-filter
                    scope="${namespace}"
                    url="./generated-mock-data/mymachine-trainings-filter.json"
                    disable-tags
                ></ux-iws-stateful-filter>
            </div>
            ${withTags
                ? html` <div class="ux-col-12">
                      <ux-iws-stateful-filter-tags
                          language="${language}"
                          scope="${namespace}"
                      ></ux-iws-stateful-filter-tags>
                  </div>`
                : ""}
        </div>
        <div class="ux-row">
            <div class="ux-col-12">
                <hr class="ux-u-d-block ux-u-mt-zero ux-u-mb-xs" />
            </div>
        </div>
        <div class="ux-row">
            <div class="ux-col-12">
                <ux-iws-stateful-trainings
                    scope="${namespace}"
                    url="./generated-mock-data/mymachine-trainings-content.json"
                    translations-namespace="${namespace}"
                    language="${language}"
                ></ux-iws-stateful-trainings>
            </div>
        </div>`;

export const Default = Template.bind({});
Default.namespace = namespace;
Default.translations = translations;

export const WithFilter = TemplateWithFilter.bind({});

export const WithFilterAndTags = TemplateWithFilter.bind({});
WithFilterAndTags.args = { withTags: true };
